module.exports = __webpack_public_path__ + "static/media/ico-new.984cd4ff.svg";